import { giphyDarkGrey } from '@giphy/colors'
import { ReactNode } from 'react'
import styled from 'styled-components'
import CreationToolGradient from '../types/gradient'
import { GradientButton } from './buttons'
import { PauseIcon } from './icons'
import ProgressBarComponent from './progress-bar'

const ProgressButton = styled(GradientButton)`
    background: ${giphyDarkGrey};
    cursor: default;
    position: relative;

    &:hover {
        animation: none;
    }

    &:active {
        opacity: 1;
    }

    span {
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
        position: relative;
    }
`

const ProgressBar = styled(ProgressBarComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

const PauseButton = styled(GradientButton)`
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    width: 42px;

    svg {
        display: block;
        height: 16px;
    }
`

type Props = {
    className?: string
    children?: ReactNode
    disabled?: boolean
    progress?: number
    gradient?: CreationToolGradient
    isUploading?: boolean
    url?: string
    onClick?: () => void
    onPause?: () => void
}

const CreationUploadButton = ({
    className,
    children,
    progress = 0,
    disabled = false,
    gradient = CreationToolGradient.IndigoPurple,
    isUploading = false,
    url,
    onClick,
    onPause,
}: Props) => {
    const colors = CreationToolGradient.colors(gradient)
    const baseProps = { disabled, className, colors, onClick }

    if (isUploading) {
        return (
            <ProgressButton className={className} colors={colors}>
                <ProgressBar progress={progress}>
                    {onPause && (
                        <PauseButton colors={colors} onClick={onPause}>
                            <PauseIcon />
                        </PauseButton>
                    )}
                </ProgressBar>
                <span>{children}</span>
            </ProgressButton>
        )
    }

    if (url) {
        return (
            <GradientButton
                {...{
                    ...baseProps,
                    as: 'a',
                    href: url,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                }}
            >
                {children}
            </GradientButton>
        )
    }

    return <GradientButton {...baseProps}>{children}</GradientButton>
}

export default CreationUploadButton
